var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRocketIdea(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.04574 20.5618C9.31809 19.2895 9.31808 17.2266 8.04574 15.9543C6.7734 14.6819 4.71053 14.6819 3.43819 15.9543C2.57033 16.8221 2.17184 19.3643 2.00618 20.8929C1.93656 21.5353 2.46469 22.0634 3.10709 21.9938C4.63572 21.8282 7.17789 21.4297 8.04574 20.5618Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4252 17.771C19.0197 18.0629 18.7143 18.4968 18.7143 18.9904C18.7143 19.3385 18.4268 19.6207 18.0722 19.6207H15.9278C15.5732 19.6207 15.2857 19.3385 15.2857 18.9904C15.2857 18.4968 14.9803 18.0629 14.5748 17.771C13.6176 17.0819 13 15.9947 13 14.7715C13 12.6886 14.7909 11 17 11C19.2091 11 21 12.6886 21 14.7715C21 15.9947 20.3824 17.0819 19.4252 17.771Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8571 20.6262C15.4707 20.6262 15.1574 20.9338 15.1574 21.3131C15.1574 21.6925 15.4707 22 15.8571 22H18.1429C18.5293 22 18.8426 21.6925 18.8426 21.3131C18.8426 20.9338 18.5293 20.6262 18.1429 20.6262H15.8571Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3079 17.5233C11.7992 16.7282 11.5 15.7877 11.5 14.7715C11.5 11.7783 14.0468 9.5 17 9.5C18.0244 9.5 18.9998 9.7741 19.837 10.2571C21.4432 8.21968 22.2129 5.63447 21.9491 3.05039C21.895 2.52017 21.4798 2.10502 20.9496 2.05091C17.9707 1.74685 14.9903 2.81614 12.8494 4.95706L10.8749 6.93154L9.63049 6.3179L9.09513 6.09247C8.10232 5.67442 6.94392 5.90769 6.17012 6.68149L4.13244 8.71917C3.90931 8.9423 3.97801 9.31615 4.26429 9.4367L5.84576 10.1026L7.09019 10.7163L6.71649 11.09C6.40032 11.4061 6.39567 11.9141 6.70612 12.2245L11.7755 17.2939C11.9224 17.4409 12.1137 17.5172 12.3079 17.5233Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRocketIdea);
export default __webpack_public_path__ + "static/media/rocket-idea.ece31fc45629d06f41625276b799a052.svg";
export { ForwardRef as ReactComponent };